"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _Divider = _interopRequireDefault(require("./Divider.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cx = _bind["default"].bind(_Divider["default"]);

function Divider(_ref) {
  var orientation = _ref.orientation,
      variant = _ref.variant;
  var classes = cx('divider', {
    'divider--vertical': orientation === 'vertical',
    'divider--indented': variant === 'indented'
  });
  return _react["default"].createElement("hr", {
    className: classes
  });
}

Divider.displayName = 'Divider';
Divider.propTypes = {
  orientation: _propTypes["default"].string,
  variant: _propTypes["default"].string
};
Divider.defaultProps = {
  orientation: 'horizontal',
  variant: 'list'
};
var _default = Divider;
exports["default"] = _default;